"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPersonalInfo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var react_hook_form_1 = require("react-hook-form");
var framer_motion_1 = require("framer-motion");
var __1 = require("../");
var styles_1 = require("../../styles");
// import { callBigcommerce } from '@/api'
var NEXT_API_BASE = '/api/bigcommerce';
var BG_URLS = function (params) { return ({
    'update-customer': {
        url: NEXT_API_BASE + "/customers/update",
        method: 'POST'
    },
    'check-customer': {
        url: NEXT_API_BASE + "/customers/check/".concat(params.email),
        method: 'GET'
    },
    'product': {
        url: NEXT_API_BASE + "/product/".concat(params.slug),
        method: 'GET'
    },
    'checkout-redirect': {
        url: NEXT_API_BASE + "/checkout/".concat(params.checkout_id),
        method: 'GET'
    },
    'login-url': {
        url: NEXT_API_BASE + "/customers/url/".concat(params.customer_id),
        method: 'POST'
    },
    'check-cart': {
        url: NEXT_API_BASE + "/customers/cart/".concat(params.cart_id),
        method: 'PUT'
    },
    'change-channels': {
        url: NEXT_API_BASE + "/customers/channel/".concat(params.customer_id),
        method: 'GET'
    },
}); };
var urlFor = function (_a) {
    var type = _a.type, body = _a.body, params = _a.params;
    if (!BG_URLS(params)[type]) {
        throw new Error("api/bigcommerce.ts -> No URL of type ".concat(type));
    }
    var _b = BG_URLS(params)[type], url = _b.url, method = _b.method;
    var options = {
        method: method,
        body: method === 'GET' ? null : JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return [url, options];
};
var callBigcommerce = function (_a) {
    var type = _a.type, _b = _a.body, body = _b === void 0 ? {} : _b, _c = _a.params, params = _c === void 0 ? {} : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var _d, url, options, res, json, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _d = __read(urlFor({ type: type, body: body, params: params }), 2), url = _d[0], options = _d[1];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, options)];
                case 2:
                    res = _e.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = _e.sent();
                    return [2 /*return*/, [json, !res.ok]];
                case 4:
                    error_1 = _e.sent();
                    return [2 /*return*/, [{ status: error_1.status, message: error_1.message, error: 'server_error' }, true]];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var Form = styled_components_1.default.form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  button {\n    &[type='submit'] {\n      margin: 0;\n      ", "\n      width: auto;\n    }\n  }\n\n  fieldset {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n\n  .half-width {\n    ", "\n  }\n\n  .message {\n    ", "\n    opacity: .4;\n    color: ", ";\n  }\n"], ["\n  button {\n    &[type='submit'] {\n      margin: 0;\n      ", "\n      width: auto;\n    }\n  }\n\n  fieldset {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n\n  .half-width {\n    ", "\n  }\n\n  .message {\n    ", "\n    opacity: .4;\n    color: ", ";\n  }\n"])), (0, styles_1.getMargin40)(true), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: calc(50% - ", ");\n    "], ["\n      width: calc(50% - ", ");\n    "])), (0, styles_1.getRelative)(15, 'desktop')), (0, styles_1.getP15)(), function (_a) {
    var theme = _a.theme;
    return theme.colors.black;
});
var textVariants = {
    animate: {
        height: 'auto',
        opacity: 1,
        transition: __assign({}, (0, styles_1.getTransition)())
    },
    exit: {
        height: 0,
        opacity: 0,
        transition: __assign({}, (0, styles_1.getTransition)())
    },
    initial: {
        height: 0,
        opacity: 0,
        transition: __assign({}, (0, styles_1.getTransition)())
    },
};
var TIME_ID = null;
exports.FormPersonalInfo = (0, react_1.memo)(function (_a) {
    var _b;
    var userData = _a.userData;
    var _c = (0, react_hook_form_1.useForm)(), register = _c.register, handleSubmit = _c.handleSubmit;
    var _d = __read((0, react_1.useState)(null), 2), data = _d[0], setData = _d[1];
    var _e = __read((0, react_1.useState)(null), 2), message = _e[0], setMessage = _e[1];
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.info('onSubmit data', data);
                    return [4 /*yield*/, callBigcommerce({ type: 'update-customer', body: __assign({}, data) })];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 1]), res = _a[0];
                    if (res.ok) {
                        setMessage('Guardado correctamente');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        setData(userData);
    }, [userData]);
    (0, react_1.useEffect)(function () {
        if (message) {
            TIME_ID && clearTimeout(TIME_ID);
            TIME_ID = setTimeout(function () { return setMessage(null); }, 3000);
        }
        return function () { return TIME_ID && clearTimeout(TIME_ID); };
    }, [message]);
    return ((0, jsx_runtime_1.jsxs)(Form, __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [(0, jsx_runtime_1.jsxs)("fieldset", { children: [(0, jsx_runtime_1.jsx)("input", { type: 'hidden', readOnly: true, name: 'id', value: (_b = data === null || data === void 0 ? void 0 : data.entityId) !== null && _b !== void 0 ? _b : '', ref: register, onChange: function () { } }), (0, jsx_runtime_1.jsx)(__1.Input, { initialValue: data === null || data === void 0 ? void 0 : data.firstName, type: 'text', name: 'first_name', label: 'Nombre', className: 'half-width', ref: register({ required: true }) }), (0, jsx_runtime_1.jsx)(__1.Input, { initialValue: data === null || data === void 0 ? void 0 : data.lastName, type: 'text', name: 'last_name', label: 'Apellido', className: 'half-width', ref: register({ required: true }) }), (0, jsx_runtime_1.jsx)(__1.Input, { initialValue: data === null || data === void 0 ? void 0 : data.email, type: 'email', name: 'email', label: 'Email', ref: register({ pattern: __1.INPUT_PATTERNS.email, required: true }) }), (0, jsx_runtime_1.jsx)(__1.Input, { type: 'password', name: 'new-password', label: 'Nueva contrase\u00F1a', ref: register })] }), (0, jsx_runtime_1.jsx)("fieldset", { children: (0, jsx_runtime_1.jsx)(__1.InputCheckbox, { label: 'Subscribe to our newsletter', name: 'newsletter', ref: register }) }), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: message && (0, jsx_runtime_1.jsx)(framer_motion_1.motion.p, __assign({ initial: 'initial', animate: 'animate', exit: 'exit', variants: textVariants, className: 'message' }, { children: message })) }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: 'submit' }, { children: 'Guardar cambios' }))] })));
});
var templateObject_1, templateObject_2;
